import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BasketService } from '@basket';
import { JourneyStepTrackerService } from '@common';
import {
  BenefitsListAdditionalItemsComponent,
  BenefitsListCoveredItemsComponent,
  BenefitsListNotCoveredItemsComponent,
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  ProgressionStepsComponent,
} from '@components';
import { CoverDetailsService } from '@data-access';
import {
  provideTranslationDictionaryMapping,
  TranslatePipe,
  TranslateService,
} from '@i18n';
import { PosthogTrackingEvents } from '@tracking';
import { posthog } from 'posthog-js';
import { ApplianceDetailsFormComponent } from '../../components/appliance-details-form/appliance-details-form.component';
import { RegisteredApplianceComponent } from '../../components/registered-appliance/registered-appliance.component';
import { FeatureMultiPlanTranslationDictionary } from '../../i18n/feature-multi-plan-dictionary.interface';
import { translation } from '../../i18n/translation.constant';
import { MultiPlanService } from '../../services/multi-plan/multi-plan.service';

@Component({
  selector: 'app-appliance-details',
  imports: [
    ApplianceDetailsFormComponent,
    BenefitsListAdditionalItemsComponent,
    BenefitsListAdditionalItemsComponent,
    BenefitsListCoveredItemsComponent,
    BenefitsListNotCoveredItemsComponent,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    ProgressionStepsComponent,
    RegisteredApplianceComponent,
    TranslatePipe,
  ],
  templateUrl: './appliance-details.component.html',
  styleUrl: './appliance-details.component.scss',
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class ApplianceDetailsComponent implements OnInit {
  private readonly basketService = inject(BasketService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly journeyStepTracker = inject(JourneyStepTrackerService);
  private readonly multiPlanService = inject(MultiPlanService);
  private readonly coverDetailsService = inject(CoverDetailsService);
  private readonly translateService = inject(
    TranslateService<FeatureMultiPlanTranslationDictionary>,
  );
  readonly selectedAppliances = this.multiPlanService.selectedAppliances;
  readonly coveredItems = this.coverDetailsService.getCoveredItems;
  readonly notCoveredItems = this.coverDetailsService.getNotCoveredItems;
  readonly additionalItems = this.coverDetailsService.getAdditionalItems;

  ngOnInit(): void {
    this.journeyStepTracker.updateStep(
      2,
      3,
      this.translateService.translate('STEP_TITLE_EXTRA_COVER_OPTIONAL'),
      false,
    );

    if (this.basketService.basketContainsBundleAppliances()) {
      this.basketService
        .removeAppliancesFromBasket()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe();
    }
    posthog.capture(PosthogTrackingEvents.MultiPlanApplianceDetailsPageLoaded);
  }
}
